import css from './SelectInput.module.css';

import React, { useState } from 'react';
import Visibility from '../Visibility/Visibility';
import StatusText from '../StatusText/StatusText';
import { SelectOption } from '../../../types/appTypes';

type SelectInputProps = {
  label?: string | React.ReactNode;
  placeholder?: string;
  name?: string;
  options: SelectOption[];
  multiple: boolean;
  value?: string | string[];
  valid?: boolean;
  secondaryClass?: string;
  isPlaceholderSelectable?: boolean;
  onChange: React.ChangeEventHandler<HTMLSelectElement> | undefined;
};

const SelectInput = ({
  label,
  placeholder,
  name,
  options,
  multiple,
  value,
  valid,
  secondaryClass,
  isPlaceholderSelectable,
  onChange,
}: SelectInputProps) => {
  const [pure, setPure] = useState<boolean>(true);
  const showError = !valid && !pure;

  let containerClass = css.selectInput;
  if (secondaryClass !== undefined) containerClass += ` ${secondaryClass}`;

  const inputClass = showError ? css.error : undefined;

  const onChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setPure(false);

    if (onChange !== undefined) {
      onChange(event);
    }
  };

  return (
    <div className={containerClass}>
      <Visibility visible={label !== undefined}>
        <label htmlFor={name}>{label}</label>
      </Visibility>
      <select
        id={name}
        name={name}
        value={value}
        multiple={multiple}
        onChange={onChangeHandler}
        required={placeholder !== undefined}
        className={inputClass}
      >
        <Visibility visible={placeholder !== undefined}>
          <option
            key=''
            value=''
            disabled={!(isPlaceholderSelectable ?? false)}
          >
            {placeholder}
          </option>
        </Visibility>
        {options.map((opt) => (
          <option key={opt.key} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <Visibility visible={showError}>
        <StatusText text='This field is required' tiny={true} error={true} />
      </Visibility>
    </div>
  );
};

export default SelectInput;
